import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function setParityClasses(selector, leftClass = 'anim-left', rightClass = 'anim-right') {
    const els = Array.from(document.querySelectorAll(selector));
    els.forEach((el, idx) => {
        el.classList.add('animate-on-scroll');
        el.classList.add(idx % 2 === 0 ? leftClass : rightClass);
    });
}

function setSingleClass(selector, className = 'anim-up') {
    const els = Array.from(document.querySelectorAll(selector));
    els.forEach((el) => {
        el.classList.add('animate-on-scroll');
        el.classList.add(className);
    });
}

export default function ScrollAnimations() {
    const location = useLocation();
    useEffect(() => {
        const isDesktop = window.innerWidth >= 769;

        // For homepage preview grid
        if (isDesktop) {
            // Desktop: simple fade-in animation
            setSingleClass('.courses-preview-grid .course-card', 'anim-up');
        } else {
            // Mobile: LTR/RTL parity animation
            setParityClasses('.courses-preview-grid .course-card');
        }

        // Parity for mission & vision cards
        setParityClasses('.mission-grid .mission-card');
        // Service cards should animate bottom-to-top: set single anim-up class
        setSingleClass('.service-card', 'anim-up');

        // For all-courses page (.courses-grid) we want sequential bottom-to-top animation on desktop
        const allCourseEls = Array.from(document.querySelectorAll('.courses-grid .course-card'));
        const teamEls = Array.from(document.querySelectorAll('.team-grid .team-card'));
        if (isDesktop) {
            // Apply anim-up and set delay per index so they animate sequentially with small gap
            const DURATION = 400; // ms animation duration
            const GAP = 80; // ms gap between start times of cards (smaller start gap)
            allCourseEls.forEach((el, idx) => {
                el.classList.add('animate-on-scroll', 'anim-up');
                el.style.setProperty('--duration', `${DURATION}ms`);
                el.style.setProperty('--delay', `${idx * GAP}ms`);
            });
            // Apply same sequential anim-up to team cards on desktop
            teamEls.forEach((el, idx) => {
                el.classList.add('animate-on-scroll', 'anim-up');
                el.style.setProperty('--duration', `${DURATION}ms`);
                el.style.setProperty('--delay', `${idx * GAP}ms`);
            });
        } else {
            // On mobile keep LTR/RTL parity
            setParityClasses('.courses-grid .course-card');
            setParityClasses('.team-grid .team-card');
            setParityClasses('.mission-grid .mission-card');
        }

        const observerOptions = {
            threshold: 0.05,
            rootMargin: '0px 0px -150px 0px',
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('in-view');
                } else {
                    entry.target.classList.remove('in-view');
                }
            });
        }, observerOptions);

        const targets = document.querySelectorAll('.animate-on-scroll');
        targets.forEach((t) => observer.observe(t));

        return () => observer.disconnect();
    }, [location.pathname]);

    return null;
}
